import { Type } from '@sinclair/typebox';
// ---- Hub extensions (HUB-099) + declared extension settings (HUB-103) ----
//
// `GET /extensions` lists the extensions ENABLED at boot. The settings routes
// serve an extension's DECLARED settings manifest (Layer A of HUB-103): the hub
// owns the storage (`tf_extension_setting`), validation and encryption; the
// extension only reads. The entry shape mirrors `HubSettingEntrySchema` plus
// `description` and `schema` (the key's JSON schema) so the admin SPA can pick
// a control without compile-time knowledge of the extension.
/** Same rule as `EXTENSION_NAME_RE` in packages/hub/src/extensions/contract.ts. */
const EXTENSION_NAME_PATTERN = '^[a-z][a-z0-9_]{1,30}$';
export const ExtensionSummarySchema = Type.Object({
    name: Type.String(),
    /** True when the extension declares a settings manifest (Layer A). */
    hasSettings: Type.Boolean(),
});
export const ExtensionListResponseSchema = Type.Object({
    extensions: Type.Array(ExtensionSummarySchema),
});
/** Which tier resolved a declared setting: a stored row, the manifest default, or nothing. */
export const ExtensionSettingSourceSchema = Type.Union([
    Type.Literal('setting'),
    Type.Literal('default'),
    Type.Literal('unset'),
]);
export const ExtensionSettingEntrySchema = Type.Object({
    key: Type.String(),
    description: Type.String(),
    /** The key's JSON schema (TypeBox output) — the admin SPA renders from it. */
    schema: Type.Unknown(),
    secret: Type.Boolean(),
    source: ExtensionSettingSourceSchema,
    /** Non-secret keys only. */
    value: Type.Optional(Type.Unknown()),
    /** Secret keys only — presence marker, never material. */
    hasValue: Type.Optional(Type.Boolean()),
    updatedAt: Type.Optional(Type.String({ format: 'date-time' })),
    updatedBy: Type.Optional(Type.Union([Type.String({ format: 'uuid' }), Type.Null()])),
});
export const ExtensionSettingsListResponseSchema = Type.Object({
    settings: Type.Array(ExtensionSettingEntrySchema),
});
export const ExtensionNameParamsSchema = Type.Object({
    name: Type.String({ pattern: EXTENSION_NAME_PATTERN }),
});
export const ExtensionSettingKeyParamsSchema = Type.Object({
    name: Type.String({ pattern: EXTENSION_NAME_PATTERN }),
    key: Type.String({ maxLength: 64 }),
});
export const ExtensionSettingPutBodySchema = Type.Object({
    value: Type.Unknown(),
});
//# sourceMappingURL=extensions.js.map